<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 雁阵系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>账号管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.platformId" placeholder="请选择平台名称" filterable>
					<el-option key="" label="请选择平台名称" value=""></el-option>
					<el-option v-for="item in platformKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>
				&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="platformId" label="平台名称" :formatter="platformFormat"></el-table-column>
                <el-table-column prop="loginType" label="登录类型">
					<template slot-scope="scope">
                        {{scope.row.loginType == 0?"自动登录":"手动登录"}}
                    </template>
				</el-table-column>
				<el-table-column prop="username" label="用户名"></el-table-column>
				<el-table-column prop="passwordFormat" label="密码"></el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="50%">
            <el-form ref="form" :model="form" label-width="150px" :rules="rules">
				<el-form-item label="平台名称" prop="platformId">
					<el-select v-model="form.platformId" placeholder="请选择平台名称" filterable>
						<el-option key="" label="请选择平台名称" value=""></el-option>
						<el-option v-for="item in platformKV" :key="item.key" :label="item.value" :value="item.key">
					</el-option>
				</el-select>
				</el-form-item>
				<el-form-item label="登录类型" prop="loginType">
					<el-select v-model="form.loginType" placeholder="请选择登录类型">
						<el-option key="" label="请选择登录类型" value = ""></el-option>
						<el-option v-for="item in loginTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用户名" prop="username">
					<el-input v-model="form.username"> </el-input>
				</el-form-item>
				<el-form-item label="登录密码" prop="password">
					<el-input v-model="form.password" show-password> </el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="contact">
					<el-input v-model="form.contact"> </el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="tel">
					<el-input v-model="form.tel"> </el-input>
				</el-form-item>
				<el-form-item label="邮箱地址" prop="email">
					<el-input v-model="form.email"> </el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchPlatformUserData, savePlatformUser, deletePlatformUser, getPlatformUser, getPromotionPlatformKV } from '../../../api/index';
export default {
    name: 'promotion-platform-user',
    data() {
        return {
            query: {
                pageNum: 1,
				platformType:0,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
			title:"",
			rules: {
                platformId: [{ required: true, message: '请选择平台', trigger: 'blur' }],
				loginType: [{ required: true, message: '请选择登录类型', trigger: 'blur' }],
				username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
				contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
				tel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
				email: [{ required: true, message: '请输入邮箱地址', trigger: 'blur' }]
            },
			platformKV:[],
			loginTypeKV:[{"key":0,"value":"自动登录"},{"key":1,"value":"手动登录"}],
			controll:{}
        };
    },
    created() {
		this.controll = getControll("promotion-platform-user");
		this.getPlatform();
        this.getData();
    },
    methods: {
		//获取平台信息
		getPlatform() {
			getPromotionPlatformKV().then(res => {
				if (res.code == 0 ) {
					this.platformKV = res.data;
				} else {
					this.$message.error(res.message);
				}
			})
		},
		platformFormat(row, column, cellValue){
			let index = this.platformKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.platformKV[index].value;
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchPlatformUserData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePlatformUser([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.$set(this.form, "platformType", 0);
			this.title = "添加账号信息";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			this.title = "编辑账号信息";
            getPlatformUser(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					savePlatformUser(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
